
<template>
  <div class="container">
    <pfx-admin-menu />
    <div v-if="loading"><InlineSpinner /></div>
    <div v-else>
      <div class="clearfix">
        <div class="col15" style="margin-top: 1rem;">
          <img :src="logoUrl" width="150" />
        </div>
        <div class="col45">
          <div><h2>Name: {{ profile.name || subdomain }}</h2></div>
          <div><TenantStatusIndicator :tenant="tenant" /></div>
          <div>URL: <a target="_blank" :href="tenantDomain">{{ tenantDomain }}</a></div>
          <div>Office Phone Number: {{ profile.officePhone || '&mdash;' }}</div>
          <!--
          <div>Fax Phone Number: {{ profile.fax || '&mdash;' }}</div>
          -->
          <div>Address: {{ profile.address || '&mdash;' }}</div>
          <!--
          <div v-if="profile.introduction"><h2>Introduction <small>(Who we are?)</small>:</h2></div>
          <div v-if="profile.introduction"><small>{{ profile.introduction }}</small></div>
          -->
          <p></P>
          <template v-if="tenant.status === tenantStatuses.ACTIVE.value">
            <button class="btn-neutral btn-small" @click="suspendTenantDialog"><v-icon dark>lock</v-icon> Suspend tenant</button>
          </template>
          <template v-if="tenant.status === tenantStatuses.SUSPENDED.value">
            <button class="btn-green btn-small" @click="unsuspendTenantDialog"><v-icon dark>lock_open</v-icon> Reactivate suspended tenant</button>
          </template>
          <template v-if="tenant.status !== tenantStatuses.DELETED.value">
            <button class="btn-danger btn-small" @click="removeTenantDialog"><v-icon dark>delete</v-icon> Delete tenant</button>
          </template>
        </div>
      </div>
      <div style="margin-top: 2rem;">
        <h3>Agents</h3>
        <v-data-table :headers="headers" :pagination.sync="pagination" :items="members" :loading="false" must-sort hide-actions item-key="id">
          <template slot="items" slot-scope="props">
            <tr>
              <td class="nowrap">{{ props.item.injected.profile.firstName }} {{ props.item.injected.profile.lastName }}</td>
              <td class="nowrap"><small>{{ props.item.injected.profile.email }}</small></td>
              <td class="nowrap">{{ props.item.role | lowercase | capitalize }}</td>
              <td class="nowrap">{{ props.item.created | prettyDate }}</td>
              <td class="nowrap"><small>{{ props.item.userId }}</small></td>
            </tr>
          </template>
        </v-data-table>
      </div>
      <div v-if="tenant.status !== tenantStatuses.DELETED.value">
        <div style="margin: 2rem 4rem 0;">
          <form ref="inviteNewAdminForm">
            <h3>Invite new admin member</h3>
            <fieldset>
              <input type="email" placeholder="Email address" v-model.trim="newAdminEmail" required />
            </fieldset>
            <div class="clearfix">
              <button @click.prevent="inviteNewAdmin" :disabled="inviteNewAdminLoading" style="float: right; margin-left: 1rem;">
                <v-icon dark>email</v-icon> Send the invitation
              </button>
              <small>
                System will send a link and an invitation token into the provided email address. The recipient must access
                the link, sign up to the PFX (if not done already earlier), login, and paste the invitation token into the form.
              </small>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div style="margin-top: 2rem; text-align: center;">
      <router-link to="/pfxadmin/tenants">&lt; Back to tenant list</router-link>
    </div>
  </div>
</template>

<script>
  import PfxAdminMenu from './PfxAdminMenu.vue'
  import InlineSpinner from './elements/InlineSpinner.vue'
  import TenantStatusIndicator from './elements/TenantStatusIndicator.vue'
  import { mapMutations } from 'vuex'
  import { tenantStatuses } from '../utils/PfxUtils.js'

  export default {
    name: 'PfxAdminViewTenant',
    components: {
      PfxAdminMenu,
      InlineSpinner,
      TenantStatusIndicator
    },
    data() {
      return {
        tenantStatuses,
        pfxLandingPageUrl: process.env.config.frontend.pfxLandingPage,
        subdomain: this.$route.params.subdomain,
        loading: true,
        tenant: {},
        profile: {},
        members: [],
        headers: [
          { text: 'Name', value: 'injected.profile.firstName' },
          { text: 'Email address', value: 'injected.profile.email' },
          { text: 'Role', value: 'role' },
          { text: 'Added', value: 'created' },
          { text: 'User ID', value: 'userId' }
        ],
        pagination: {
          sortBy: 'injected.profile.firstName', descending: false, rowsPerPage: 100000000
        },
        newAdminEmail: '',
        inviteNewAdminLoading: false
      }
    },
    computed: {
      logoUrl() {
        return this.profile.extLogoUrl || this.profile.logoUrl || require('../assets/placeholder-logo.png')
      },
      tenantDomain() {
        return this.pfxLandingPageUrl.replace(/\/\//, '//' + this.subdomain + '.')
      },
    },
    created() {
      this.loadTenant()
    },
    methods: {
      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      loadTenant() {
        this.loading = 3

        this.$PfxBackendApi.getTenantPublic(this.subdomain).then(res => {
          console.log('getTenantPublic res', res)
          this.profile = res.data || {}
        }).catch(err => {
          if (err.status !== 404) {
            console.error('getTenantPublic err', err)
            this.$notify({type: 'danger', message: 'Unexpected error during loading tenant profile'})
          }
        }).then(() => this.loading--)

        this.$PfxBackendApi.getPfxAdminTenants().then(res => {
          console.log('getPfxAdminTenants res', res)
          const tenants = res.data || []
          this.tenant = tenants.find(tenant => tenant.subdomain === this.subdomain)
        }).catch(err => {
          console.error('getPfxAdminTenants err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading tenants' })
        }).then(() => this.loading--)

        this.$PfxBackendApi.getPfxAdminTenantMembers(this.subdomain).then(res => {
          console.log('getPfxAdminTenantMembers res', res)
          const members = res.data || []
          this.loading += members.length
          members.forEach(member => {
            member.injected = {}
            member.injected.profile = {}
            this.$PfxBackendApi.getUser(member.userId).then(res => {
              console.log('getUser res', res)
              member.injected.profile = res.data || {}
            }).catch(err => {
              console.error('getUser (member) err', err)
            }).then(() => this.loading--)
          })
          this.members = members
        }).catch(err => {
          console.error('getPfxAdminTenantMembers err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during loading tenant members/agents' })
        }).then(() => this.loading--)
      },

      suspendTenantDialog() {
        this.$store.commit('openDialog', {
          text: 'Suspending a tenant will make their website not accessible by end users.\n\nSuspended tenant can be later made active again.\n\nContinue?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            {
              title: 'Suspend tenant', class: 'btn-danger',
              handler: () => {
                this.$store.commit('closeDialog')
                this.suspendTenant()
              }
            }
          ]
        })
      },

      suspendTenant() {
        this.$PfxBackendApi.postPfxAdminTenantStatus(this.subdomain, 'SUSPENDED').then(res => {
          console.log('postPfxAdminTenantStatus res', res)
          this.$notify({ type: 'info', message: 'Tenant status is now set to SUSPENDED' })
          this.loadTenant()
        }).catch(err => {
          console.error('postPfxAdminTenantStatus err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during setting tenant status' })
        })
      },

      unsuspendTenantDialog() {
        this.$store.commit('openDialog', {
          text: 'Reactivating a suspended tenant will make their website again accessible by end users.\n\nContinue?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            {
              title: 'Reactivate tenant', class: 'btn-green',
              handler: () => {
                this.$store.commit('closeDialog')
                this.unsuspendTenant()
              }
            }
          ]
        })
      },

      unsuspendTenant() {
        this.$PfxBackendApi.postPfxAdminTenantStatus(this.subdomain, 'ACTIVE').then(res => {
          console.log('postPfxAdminTenantStatus res', res)
          this.$notify({ type: 'info', message: 'Tenant status is now set to ACTIVE' })
          this.loadTenant()
        }).catch(err => {
          console.error('postPfxAdminTenantStatus err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during setting tenant status' })
        })
      },

      removeTenantDialog() {
        this.$store.commit('openDialog', {
          text: 'Removing tenant will permanently delete all tenant information, including member roles, auctions, bids, etc.\n\nThis cannot be undone.\n\nAre you sure?',
          buttons: [
            { title: 'Cancel', class: 'btn-neutral' },
            {
              title: 'Delete tenant', class: 'btn-danger',
              handler: () => {
                this.$store.commit('closeDialog')
                this.removeTenant()
              }
            }
          ]
        })
      },

      removeTenant() {
        this.$PfxBackendApi.deletePfxAdminTenant(this.subdomain).then(res => {
          console.log('removePfxAdminTenant res', res)
          this.$notify({ type: 'info', message: 'Tenant removed' })
          this.$router.push('/pfxadmin/tenants')
        }).catch(err => {
          console.error('removePfxAdminTenant err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error during removing tenant' })
        })
      },

      inviteNewAdmin() {
        if (!this.$refs.inviteNewAdminForm.checkValidity()) {
          this.$refs.inviteNewAdminForm.reportValidity()
          return
        }
        this.inviteNewAdminLoading = true
        this.$PfxBackendApi.postPfxAdminTenantMemberInvite(this.subdomain, this.newAdminEmail).then(res => {
          console.log('postPfxAdminTenantMemberInvite res', res)
          if (res.status === 201) {
            this.$notify({ type: 'info', message: 'Invitation sent' })
            this.newAdminEmail = ''
          } else {
            this.$notify({ type: 'danger', message: 'Unexpected status (' + res.status + ') while sending invitation' })
          }
        }).catch(err => {
          console.error('postPfxAdminTenantMemberInvite err', err)
          this.$notify({ type: 'danger', message: 'Unexpected error while sending invitation' })
        }).then(() => this.inviteNewAdminLoading = false)
      }

    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col15 { @include column(1/5); }
  .col45 { @include column(4/5); }
  .user-avatar { width: 100%; }

</style>



// WEBPACK FOOTER //
// src/components/PfxAdminViewTenant.vue